import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ModalForm from "../general/ModalForm";
import Loading from "../general/Loading";

function ParametrosModuloContable() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    const [encabezadoFactura, setEncabezadoFactura] = useState();
    const [ultimoConsecutivoFactura, setUltimoConsecutivoFactura] = useState();
    const [encabezadoOrdenCompra, setEncabezadoOrdenCompra] = useState();
    const [ultimoConsecutivoOrdenCompra, setUltimoConsecutivoOrdenCompra] = useState();
    const [encabezadoEgreso, setEncabezadoEgreso] = useState();
    const [ultimoConsecutivoEgreso, setUltimoConsecutivoEgreso] = useState();
    const [encabezadoEquipos, setEncabezadoEquipos] = useState();
    const [ultimoConsecutivoEquipos, setUltimoConsecutivoEquipos] = useState();
    const [encabezadoMedicamentos, setEncabezadoMedicamentos] = useState();
    const [ultimoConsecutivoMedicamentos, setUltimoConsecutivoMedicamentos] = useState();
    const [encabezadoInsumos, setEncabezadoInsumos] = useState();
    const [ultimoConsecutivoInsumos, setUltimoConsecutivoInsumos] = useState();
    const [tipoEntidad, setTipoEntidad] = useState();

    const [parametrosId, setParametrosId] = useState();

    const [errorlist, setErrorlist] = useState({});
    
    const [parametrosExisten, setParametrosExisten] = useState(false);

    let history = useHistory();

    let userdata = [];
    let clientData = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        axios.get('parametros-modulo-contable?uid='+userdata.user_id,config)
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    setParametrosExisten(true);
                    setParametrosId(response.data.id);

                    setEncabezadoFactura(response.data.encabezado_factura);
                    setUltimoConsecutivoFactura(response.data.ultimo_consecutivo_factura);
                    setEncabezadoOrdenCompra(response.data.encabezado_orden_compra);
                    setUltimoConsecutivoOrdenCompra(response.data.ultimo_consecutivo_orden_compra);
                    setEncabezadoEgreso(response.data.encabezado_egreso);
                    setUltimoConsecutivoEgreso(response.data.ultimo_consecutivo_egreso);
                    setEncabezadoEquipos(response.data.encabezado_equipos);
                    setUltimoConsecutivoEquipos(response.data.ultimo_consecutivo_equipos);
                    setEncabezadoMedicamentos(response.data.encabezado_medicamentos);
                    setUltimoConsecutivoMedicamentos(response.data.ultimo_consecutivo_medicamentos);
                    setEncabezadoInsumos(response.data.encabezado_insumos);
                    setUltimoConsecutivoInsumos(response.data.ultimo_consecutivo_insumos);
                    setTipoEntidad(response.data.tipo_entidad);
                }
            })
            .catch(error => console.log(error.response.data))
        
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            encabezado_factura: encabezadoFactura,
            ultimo_consecutivo_factura: ultimoConsecutivoFactura,
            encabezado_orden_compra: encabezadoOrdenCompra,
            ultimo_consecutivo_orden_compra: ultimoConsecutivoOrdenCompra,
            encabezado_egreso: encabezadoEgreso,
            ultimo_consecutivo_egreso: ultimoConsecutivoEgreso,
            encabezado_equipos: encabezadoEquipos,
            ultimo_consecutivo_equipos: ultimoConsecutivoEquipos,
            encabezado_medicamentos: encabezadoMedicamentos,
            ultimo_consecutivo_medicamentos: ultimoConsecutivoMedicamentos,
            encabezado_insumos: encabezadoInsumos,
            ultimo_consecutivo_insumos: ultimoConsecutivoInsumos,
            tipo_entidad: tipoEntidad
        };
        
        if (parametrosExisten) {
            conf.id = parametrosId;
            axios.put('/parametros-modulo-contable', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los Parámetros Del Módulo Contable Han Sido Modificados');
                        history.push('/parametros-sistema');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        else {
            axios.post('/parametros-modulo-contable', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los Parámetros Del Módulo Contable Han Sido Creados');
                        history.push('/parametros-sistema');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Parametros y Consecutivos Módulo Contable</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Parametros y Consecutivos Módulo Contable</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-10">
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    <fieldset>
                                                        <legend>Consecutivo De Factura</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Encabezado</label>
                                                                    <input type="text" name="encabezadoFactura" className="form-control" id="encabezadoFactura" value={encabezadoFactura} onChange={(e) => setEncabezadoFactura(e.target.value)} autoFocus />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.encabezado_factura}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Último Consecutivo</label>
                                                                    <input type="text" name="ultimoConsecutivoFactura" className="form-control" id="ultimoConsecutivoFactura" value={ultimoConsecutivoFactura} onChange={(e) => setUltimoConsecutivoFactura(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.ultimo_consecutivo_factura}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset>
                                                        <legend>Consecutivo Orden de Compra</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Encabezado</label>
                                                                    <input type="text" name="encabezadoOrdenCompra" className="form-control" id="encabezadoOrdenCompra" value={encabezadoOrdenCompra} onChange={(e) => setEncabezadoOrdenCompra(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.encabezado_orden_compra}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Último Consecutivo</label>
                                                                    <input type="text" name="ultimoConsecutivoOrdenCompra" className="form-control" id="ultimoConsecutivoOrdenCompra" value={ultimoConsecutivoOrdenCompra} onChange={(e) => setUltimoConsecutivoOrdenCompra(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.ultimo_consecutivo_orden_compra}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset>
                                                        <legend>Consecutivo de Egreso</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Encabezado</label>
                                                                    <input type="text" name="encabezadoEgreso" className="form-control" id="encabezadoEgreso" value={encabezadoEgreso} onChange={(e) => setEncabezadoEgreso(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.encabezado_egreso}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Último Consecutivo</label>
                                                                    <input type="text" name="ultimoConsecutivoEgreso" className="form-control" id="ultimoConsecutivoEgreso" value={ultimoConsecutivoEgreso} onChange={(e) => setUltimoConsecutivoEgreso(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.ultimo_consecutivo_egreso}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset>
                                                        <legend>Código de Equipos</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Encabezado</label>
                                                                    <input type="text" name="encabezadoEquipos" className="form-control" id="encabezadoEquipos" value={encabezadoEquipos} onChange={(e) => setEncabezadoEquipos(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.encabezado_equipos}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Último Consecutivo</label>
                                                                    <input type="text" name="ultimoConsecutivoEquipos" className="form-control" id="ultimoConsecutivoEquipos" value={ultimoConsecutivoEquipos} onChange={(e) => setUltimoConsecutivoEquipos(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.ultimo_consecutivo_equipos}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset>
                                                        <legend>Código de Medicamentos</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Encabezado</label>
                                                                    <input type="text" name="encabezadoMedicamentos" className="form-control" id="encabezadoMedicamentos" value={encabezadoMedicamentos} onChange={(e) => setEncabezadoMedicamentos(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.encabezado_medicamentos}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Último Consecutivo</label>
                                                                    <input type="text" name="ultimoConsecutivoMedicamentos" className="form-control" id="ultimoConsecutivoMedicamentos" value={ultimoConsecutivoMedicamentos} onChange={(e) => setUltimoConsecutivoMedicamentos(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.ultimo_consecutivo_medicamentos}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset>
                                                        <legend>Código de Insumos y Dispositivos</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Encabezado</label>
                                                                    <input type="text" name="encabezadoInsumos" className="form-control" id="encabezadoInsumos" value={encabezadoInsumos} onChange={(e) => setEncabezadoInsumos(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.encabezado_insumos}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Último Consecutivo</label>
                                                                    <input type="text" name="ultimoConsecutivoInsumos" className="form-control" id="ultimoConsecutivoInsumos" value={ultimoConsecutivoInsumos} onChange={(e) => setUltimoConsecutivoInsumos(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.ultimo_consecutivo_insumos}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset>
                                                        <legend>Parámetros Tipo Entidad</legend>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <select name="tipoEntidad" className="form-control" id="tipoEntidad" value={tipoEntidad} onChange={(e) => setTipoEntidad(e.target.value)}>
                                                                        <option></option>
                                                                        <option value="ips">IPS</option>
                                                                        <option value="profesionales">PROFESIONALES INDEPENDIENTES</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                    {errorlist.tipo_entidad}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    


                                                    <button type="submit" className="btn btn-primary">
                                                        Guardar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosModuloContable;